import { render, staticRenderFns } from "./PersonalBetdetails.vue?vue&type=template&id=dd0cd138&"
import script from "./PersonalBetdetails.vue?vue&type=script&lang=js&"
export * from "./PersonalBetdetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonalBetdetails.vue?vue&type=style&index=0&id=dd0cd138&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports